import { productStateConfig } from '../constants/productStateConfig';
import { ProductBuilderMachineState } from '../types';

type GetStateKey = (
  productType: string | void,
  stateName: ProductBuilderMachineState,
  option: string,
) => { showIcon?: boolean; Icon?: Function; description?: string };

export const getProductStateConfig: GetStateKey = (
  productType,
  stateName,
  option,
) => {
  if (!productType) return {};
  const stateConfig = productStateConfig[productType][stateName];
  if (!stateConfig) return {};
  const showIcon =
    stateConfig[option] && stateConfig[option].icon ? true : false;
  return {
    showIcon,
    Icon: stateConfig[option]?.icon,
    description: stateConfig[option]?.description,
  };
};
